'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosStopwatchOutline = function IoIosStopwatchOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.1 11.5c2.5 2.7 3.9 6.2 3.9 10 0 8.1-6.7 14.8-15 14.8s-15-6.7-15-14.8c0-3.8 1.4-7.4 4-10.1l0.1-0.1h-1.4l-0.7 0.7-1.8-1.8 3.2-3.2 1.8 1.8-0.7 0.7v1.4c2.5-2.4 5.7-3.9 9.1-4.2h0.2v-3h2.5v3c3.3 0.3 6.4 1.7 8.8 3.8l0.4 0.4v-1.4l-0.7-0.7 1.8-1.8 3.2 3.2-1.8 1.8-0.7-0.7h-1.4z m-11.1 23.3c7.5 0 13.5-6 13.5-13.3s-6-13.4-13.5-13.4c-7.4 0-13.5 6-13.5 13.4s6 13.3 13.5 13.3z m0.6-14.7c1.1 0.3 1.9 1.3 1.9 2.4 0 1.2-0.8 2-1.9 2.3l-0.6 1.5-0.6-1.5c-1.1-0.3-1.9-1.1-1.9-2.3 0-1.1 0.9-2.1 1.9-2.4v-10.1h1.2v10.1z' })
        )
    );
};

exports.default = IoIosStopwatchOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-stopwatch-outline.js
// module id = 2292
// module chunks = 0